import Vue from 'vue'
import dynStorage from '@/utils/storage-dynamic'
import axios from '@/utils/axios-intents'

let BROADBAND_FLOW_ID = 0
const BROADBAND_FLOW = 'broadband-flow'

export function mapAddressItems(address) {
    return {
        LocationProvider: address.LocationProvider,
        LocationProviderIDX: address.LocationProviderIDX,
        BuildingName: address.BuildingName ?? '',
        AddressType: address.AddressType ?? '',
        UnitType: address.UnitType ?? '',
        UnitTypeExtra: address.UnitTypeExtra ?? '',
        Number: address.Number ?? '',
        NumberPre: address.NumberPre ?? '',
        NumberPost: address.NumberPost ?? '',
        StreetName: address.StreetName ?? '',
        StreetType: address.StreetType ?? '',
        State: address.State ?? '',
        Suburb: address.Suburb ?? '',
        Country: address.Country ?? "New Zealand",
        Latitude: address.Latitude ?? 0,
        Longitude: address.Longitude ?? 0,
        City: address.City ?? '',
        Postcode: address.PostCode ?? '',
        Lines: [
            [
                `${address.NumberPre}${address.NumberPre ? '/' : ''}${address.Number}${address.NumberPost}`,
                address.StreetName,
                address.StreetType,
            ].join(' ').trim(),
            [
                address.BuildingName,
                address.Suburb,
            ].join(' ').trim(),
        ].filter(line => Boolean(line)),
        Formatted: address.Formatted,
        AddressUUID: address.UUID,
        Description: address.Formatted,
        IsDefault: address.Rank == 1,
    }
}

export function formatCartAddress(address) {
    if (!address) return '';
    
    let formattedAddress = '';
    if (address.Lines && address.Lines.length) {
        formattedAddress = address.Lines.filter(line => line).join(', ');
    }
    
    if (address.City) {
        formattedAddress += formattedAddress ? ', ' + address.City : address.City;
    }
    
    if (address.Postcode) {
        formattedAddress += ' ' + address.Postcode;
    }
    
    return formattedAddress;
}

const state = {
    broadband_flow: {},
}

const getters = {
    broadband_flow: state => state.broadband_flow,
}

const mutations = {
    saveBroadbandFlow(state, broadband_flow) {
        const { id, uuid, location, transfer, service, plan, with_wifi_router, rsf, broadband_device } = broadband_flow

        if (!id) {
            broadband_flow.id = `ufb-${ (new Date()).getTime() }${ ++BROADBAND_FLOW_ID }`
        }

        const stored_broadband_flow = {
            id: broadband_flow.id,
            uuid: uuid,
            location: {
                Formatted: location.Formatted,
                City: location.City,
                Country: location.Country,
                Postcode: location.Postcode,
                Lines: location.Lines,
                LocationProvider: location.LocationProvider,
                LocationProviderIDX: location.LocationProviderIDX,
                Delivery: {
                    instructions: location.Delivery?.instructions,
                    address: location.Delivery?.address,
                    phone: location.Delivery?.phone,
                    picked_address_type: location.Delivery?.picked_address_type,
                }
            },
            transfer: transfer,
            service: {
                ID: service?.ID ?? null,
            },
            plan: {
                ID: plan.ID,
                Name: plan.Name,
                Description: plan.Description,
                Price: plan.Price,
                ProductCatalogUUID: plan.ProductCatalogUUID,
                BroadbandProductType: plan.BroadbandProductType,
                OrderType: plan.OrderType,
                Attributes: ( plan.BroadbandProductType == 'UFB' ? plan.UFB_Attributes : plan.FWA_Attributes ) || [] 
            },
            with_wifi_router: with_wifi_router || false,
            rsf: rsf || {},
            broadband_type: plan.BroadbandProductType || 'UFB',
            broadband_device: broadband_device || {},
        }

        dynStorage.set(BROADBAND_FLOW, stored_broadband_flow, false, true)

        state.broadband_flow = broadband_flow
    },

    setBroadbandUUID(state, uuid) {
        if (uuid) {
            Vue.set(state.broadband_flow, 'uuid', uuid)
        } else {
            Vue.delete(state.broadband_flow, 'uuid')
        }
    },

    setBroadbandModemInfo(state, modem) {
        if (modem && Object.keys(modem).length) {
            Vue.set(state.broadband_flow, 'modem', {
                ID: modem.UUID,
                Name: modem.Name,
                PriceCents: modem.PriceCents || 0,
            })
        } else {
            Vue.delete(state.broadband_flow, 'modem')
        }
    },

    loadBroadbandFlow() {
        if (!Object.keys(state.broadband_flow).length) {
            state.broadband_flow = dynStorage.get(BROADBAND_FLOW, true) || {}
        }
    },

    resetBroadbandFlow() {
        state.broadband_flow = {}
        dynStorage.remove(BROADBAND_FLOW)
    },
}

const actions = {
    loadBroadbandModemInfo({getters, commit, dispatch}, broadband_flow) {
        if (broadband_flow.broadband_type == 'FWA') {
            return Promise.resolve(null)
        }
        return dispatch('ufbCart', broadband_flow).then(({data}) => {
            const modem = Array.isArray(data?.Items)
                ? data.Items.find(item => item.Type == "TYPE_PRODUCT" && item.VirtualType == "VT_NONE")
                : null

            commit('setBroadbandUUID', data?.UUID)
            commit('setBroadbandModemInfo', modem)
            commit('saveBroadbandFlow', getters.broadband_flow)

            return Promise.resolve(getters.broadband_flow.modem)
        })
    },

    broadbandSearchAddress({}, payload) {
        return axios.get('/broadband/v1/search_address', { params: payload })
            .then(({data}) => Promise.resolve(data))
    },

    broadbandGetPlansCatalog({getters}, { Location, ProductType }) {
        const payload = {
            LocationProvider: Location.LocationProvider,
            LocationProviderIDX: Location.LocationProviderIDX,
            //ProductType: ProductType //ProductType: 'UFB' @todo revert this back when ufb is available
            ProductType: 'FWA'
        }


        return axios.get('/broadband/v1/plans', { params: payload })
            .then(({data}) => {
                if (data.ServiceAvailability && data.ServiceAvailability.Status) {
                    const Status = data?.ServiceAvailability?.Status ?? null

                    console.log('Status', Status)

                    if (Status == 'Available') {
                        return Promise.resolve({ ...data})
                    } else {
                        const errorMessage = ProductType == 'FWA' 
                            ? 'Wireless Broadband is unavailable' 
                            : 'Fibre services are unavailable'

                            const mockData = {
                                Plans: [
                                    {
                                        ProductAvailabilityUUID: "3307fad1-8afd-4ec5-b008-f31aebbe5fcf",
                                        RetailCents: 500,
                                        PriceOverride: 500,
                                        Name: "Mobile Fixed Wireless Base Add-On Test",
                                        ProductCatalogUUID: "c19a4c71-ea1e-4c35-bc95-b3c8a22c064d",
                                    }
                                ],
                            }
                            return Promise.resolve({ ...mockData})
    
                        //return Promise.reject(new Error(errorMessage))
                    }
                } else {
                    return Promise.reject(new Error('No service availability data'))
                }
            }).catch(error => {
                console.log('error', error)
                return Promise.reject(error)
            })
        },

        
}

export default {
    state,
    getters,
    mutations,
    actions,
}
